import { ApiProperty } from '@nestjs/swagger'

export class PedagogyNearContentLessonDto {
  @ApiProperty({ format: 'uuid' })
  lessonId!: string

  @ApiProperty({ format: 'uuid' })
  chapterId!: string

  @ApiProperty()
  title!: string

  @ApiProperty({ format: 'uuid' })
  subjectExternalId!: string

  /** Nombre de programConceptId cibles couverts par cette leçon */
  @ApiProperty()
  score!: number

  /** ProgramConcept.id recoupés avec les cibles (pour prioriser selon l’ordre Analytics) */
  @ApiProperty({ type: [String], format: 'uuid' })
  matchedProgramConceptIds!: string[]
}

export class PedagogyNearContentChapterDto {
  @ApiProperty({ format: 'uuid' })
  chapterId!: string

  @ApiProperty()
  title!: string

  @ApiProperty({ format: 'uuid' })
  subjectExternalId!: string

  @ApiProperty()
  score!: number

  @ApiProperty({ type: [String], format: 'uuid' })
  matchedProgramConceptIds!: string[]
}

export class PedagogyNearContentResponseDto {
  @ApiProperty({ type: [String], format: 'uuid' })
  programConceptIds!: string[]

  @ApiProperty({ type: () => [PedagogyNearContentLessonDto] })
  lessons!: PedagogyNearContentLessonDto[]

  @ApiProperty({ type: () => [PedagogyNearContentChapterDto] })
  chapters!: PedagogyNearContentChapterDto[]
}
